module.exports = __webpack_public_path__ + "img/icon7.0b753a42.0b753a42.svg";